<template>
    <div class="d-flex flex-xl-row flex-column">
      <div class="e-card__content d-none d-xl-flex">
        <b-table hover outlined class="e-table e-table--filter--gray-scale" :fields="lineTableFields" :items="tableItems" @row-clicked="onRowClicked">
          <template slot="coin" slot-scope="data">
            <div class="d-flex align-items-center">
              <div class="e-avatar size-30 mr-4">
                <img src="../../../assets/assets/bitcoin.svg">
              </div>
              <div class="d-flex flex-column">
                <b>{{ data.item.asset }}</b>
                <small class="eh-secondary-text">BTC</small>
              </div>
            </div>
          </template>
        </b-table>
      </div>
      <div class="e-card__content d-flex d-xl-none align-items-center">
        <b-btn class="e-btn e-btn--size--small e-btn--outlined e-btn--color--blue-light"
               :class="{'e-btn--type--select': chartVisible}"
               @click="chartVisible = !chartVisible">
          {{ chartVisible ? 'Show coins' : 'Apply' }}
        </b-btn>
        <p v-show="!chartVisible" class="eh-secondary-text ml-auto">Selected {{ selectedItems.length }} of {{ this.maxSelected }}</p>
        <div class="e-scroll e-scroll--x" v-show="chartVisible">
          <div class="e-scroll__wrapper">
            <b-btn v-for="(item, key) in selectedItemsObject"
                   class="e-btn e-btn--outlined e-btn--size--small e-btn--fill font-weight-bold"
                   @click="onRowClicked(item, item.index)"
                   :class="[`e-btn--color--${item.__color}`]"
                   :key="key">
              {{ item.asset }} <span class="close"></span>
            </b-btn>
          </div>
        </div>
      </div>
      <div class="line-chart" v-show="isShowChart">
        <transition-group name="fade" mode="out-in">
          <highcharts key="chart" v-show="selectedItems.length > 0" :options="chartOptions" ref="chart" class="line-chart__container"></highcharts>
          <div key="empty" class="line-chart__empty" v-show="selectedItems.length <= 0">
            <p>Please, select data</p>
          </div>
        </transition-group>
      </div>
      <div v-if="!isShowChart" class="e-card__content e-line-chart-list d-flex d-xl-none row">
        <div v-for="(item, key) in tableItems" class="col-6 col-sm-4">
          <eb-line-chart-list-item :item="item" @click="onRowClicked(item, key)"></eb-line-chart-list-item>
        </div>
      </div>
    </div>
</template>

<script>
  import _ from 'lodash'
  import EbLineChartListItem from "./listItem";

  const MAX_SELECTED_ITEMS = 3;

  const COLORS = {
    red: '#ff5656',
    // cyan: '#00c2ff',
    'blue-dark': '#1354aa',
    orange: '#ffab48'
  };

  // colors: ['#0e3d60', '#0e4b6e', '#0e648c', '#116091', '#1472ad', '#1490cb'],


  export default {
		name: "eb-line-chart",
    components: {EbLineChartListItem},
    props: {
		  maxSelected: {
		    type: Number,
        default: MAX_SELECTED_ITEMS,
      },
    },
    computed: {
      isShowChart() {
        return this.chartVisible;
      },
		  selectedItemsObject() {
		    return this.selectedItems.map(index => {
		      return {
		        index: index,
            ...this.tableItems[index]
		      }
		    });
      },
      chartOptions() {
        return {
          chart: {
            type: 'line',
            scrollablePlotArea: {
              minWidth: 700,
              scrollPositionX: -1
            },
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
          },
          title: {
            text: '',
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: false,
          },
          tooltip: {
            shared: true,
          },
          xAxis: {
            gridLineWidth: 0,
            lineWidth: 0,
            tickWidth: 0,
            categories: ['13.07', '14.07', '15.07', '16.07', '17.07', '18.07', '19.07', '20.07', '21.07', '22.07', '23.07', '24.07', '25.07', '26.07', '27.07'],
            tickmarkPlacement: 'on',
            title: {
              text: ''
            }
          },
          yAxis: {
            gridLineWidth: 0,
            title: {
              text: ''
            }
          },
          colors: Object.values(COLORS),
          plotOptions: {
            series:{
              dataLabels: {
                enabled: false
              }
            },
          },
          series: this.rawItems.map(item => {
            return this.prepareSeries({name: item.name, data: item.data});
          })
        }
      }
    },
    methods: {
		  // TODO rebase to mixin
      getFreeColor() {
        return _.findKey(COLORS, (hex, color) => {
          return !this.usedColors.includes(color);
        });
      },
      lockColor(color) {
        this.usedColors.push(color);
      },
      unlockColor(color) {
        this.usedColors.splice(this.usedColors.indexOf(color), 1);
      },

      onRowClicked(item, index) {
        const items = _.clone(this.selectedItems, true);
        if(items.includes(index)) {
          items.splice(this.selectedItems.indexOf(index), 1);
          this.selectedItems = items;
        } else {
          if(items.length < this.maxSelected) {
            items.push(index);
            this.selectedItems = items;
          }
        }

      },

      // Chart functions
      prepareSeries({name, data}) {
        return {
          name: name,
          marker:{
            enabled: false,
          },
          data: data,
          visible: false,
          type: "spline"
        }
      },
      showSeries(index) {
        this.$nextTick(() => {
          const color = COLORS[this.tableItems[index].__color];
          const chart = this.$refs.chart.chart;
          const series = chart.series[index];

          // chart.legend.colorizeItem(series, series.visible);
          series.color = color;
          series.graph.attr({
            stroke: color
          });

          series.show();
        })
      },
      hideSeries(index) {
        this.$nextTick(() => {
          this.$refs.chart.chart.series[index].hide()
        });
      }
    },
    watch: {
		  selectedItems: {
		    handler(current, preview) {
		      // Looked at new active series
          _.difference(current, preview || []).forEach(i => {
            const color = this.getFreeColor();
            this.tableItems[i]._rowVariant = `row-active table-row-active--color--${color}`
            this.tableItems[i].__color = color;
            this.lockColor(color);
            this.showSeries(i);
          });

          // Looked at deactivated series
          if(preview) {
            _.difference(preview, current).forEach(i => {
              this.tableItems[i]._rowVariant = null;
              this.unlockColor(this.tableItems[i].__color);
              this.tableItems[i].__color = null;
              this.hideSeries(i);
            });
          }

        },
        immediate: true,
      }
    },
    data() {
		  const items = [
		    {
          asset: 'Bitcoin',
          isActive: false,
          data: [3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 6.6, 4.8, 3, 5, 6, 7, 8],
        },
        {
          asset: 'Ethereum',
          isActive: false,
          data: [2.9, 4.2, 7.7, 1.5, 11.9, 15.2, 17.0, 16.6, 14.2, 10.3, 10.6, 4.8, 3, 5, 8, 7, 8],
        },
        {
          asset: 'Neo',
          isActive: false,
          data: [3.9, 2, 5.0, 8.5, 41.9, 15.2, 17.0, 16.6, 15.2, 10.3, 6.6, 4.8, 3, 5, 6, 7, 8],
        },
        {
          asset: 'Stratis',
          isActive: false,
          data: [5.9, 10, 5.7, 8.5, 11.7, 13, 11.0, 16.2, 14.8, 10.3, 6.6, 2.8, 3, 5, 10, 7, 8],
        },
      ];

		  return {
        resizeListener: null,
		    chartVisible: true,
		    usedColors: [],
        lineTableFields: [
          {
            label: 'Show',
            key: 'coin'
          },
        ],
        rawItems: items,
        tableItems: items.map(i => {
          return {
            asset: i.asset,
            _rowVariant: null,
          }
        }),
        selectedItems: [2,3],
      }
    },
    created() {
		  this.resizeListener = window.addEventListener('resize', () => {
		    this.chartVisible = true;
      })
    },
    destroyed() {
		  removeEventListener({}, this.resizeListener);
    }
	}
</script>

<style scoped lang="scss">
  .item-card {
    padding: 10px;
    border: 1px solid gray;
  }

  .close {
    width: 8px;
    height: 8px;
    background: url('/static/icons/close-1.svg') no-repeat center;
    margin-left: 8px;
  }

  .line-chart {
    overflow: scroll;
    padding: 30px 0;
    width: 100%;

    .line-chart__container {
      /*overflow: scroll;*/
    }

    .line-chart__empty {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: #ccd6dd;
      font-size: 16px;
      font-family: Roboto, sans-serif;
    }
  }

  @media screen and (max-width: 767px) {
    .line-chart {
      padding: 18px 0 8px;
    }

    .e-line-chart-list {
      margin-left: -6px;
      margin-right: -6px;

      & > div {
        padding-left: 6px;
        padding-right: 6px;
        margin-bottom: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/lineChart/lineChart.vue